var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9733 4.0268C26.8133 2.8668 25.1733 2.41347 23.5866 2.81347L10.52 6.08014C8.31995 6.6268 6.62662 8.33347 6.07995 10.5201L2.81329 23.6001C2.41329 25.1868 2.86662 26.8268 4.02662 27.9868C4.90662 28.8535 6.06662 29.3335 7.26662 29.3335C7.63995 29.3335 8.02662 29.2935 8.39996 29.1868L21.48 25.9201C23.6666 25.3735 25.3733 23.6801 25.92 21.4801L29.1866 8.40014C29.5866 6.81347 29.1333 5.17347 27.9733 4.0268ZM16 21.1735C13.1466 21.1735 10.8266 18.8535 10.8266 16.0001C10.8266 13.1468 13.1466 10.8268 16 10.8268C18.8533 10.8268 21.1733 13.1468 21.1733 16.0001C21.1733 18.8535 18.8533 21.1735 16 21.1735Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.98fbe2382dc6df2bcc2d398d909acca3.svg";
export { ForwardRef as ReactComponent };